// 1.0 导入vue核心包
import Vue from "vue";

// 2.0 导入App.vue的vue对象
import App from "./App.vue";

// 3.0 将vue-router集成到这个项目中来
import vueRouter from "vue-router";
// 3.0.1 将vueRouter对象绑定到Vue对象上
Vue.use(vueRouter);

//导入一个全局的scss
// import "../statics/css/comment.scss";

//导入Vant
// import Vant from 'vant';
// import 'vant/lib/vant-css/index.css';
import "vant/lib/index.css";
// Vue.use(Vant);

//引入复制插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
// import { Toast } from 'vant'
// Vue.use(Toast);
import VueDOMPurifyHTML from 'vue-dompurify-html'
Vue.use(VueDOMPurifyHTML)

import TFWebLog from 'tf_web_log'
var tfWebLog = TFWebLog.getInstance()
// 1H5  2web  3老师端windows  4跟进页  5小程序 6安卓 7ios 8学员端PC端  9老师端Mac
tfWebLog.init(1)
Vue.prototype.$TFWebLog = tfWebLog

// 3.0.2 导入路由规则对应的组件对象
import home from "./components/Home.vue";
import user from "./components/Modular/UserInfo.vue";
import invite from "./components/Modular/InviteCard.vue";
import rewardRedBag from "./components/Modular/rewardRedBag.vue";
import Setting from "./components/Modular/Setting.vue";
import income from "./components/Modular/income.vue";
import passWord from "./components/Modular/passWord.vue";
import expend from "./components/Modular/expend.vue";
import prizes from "./components/Modular/prizes.vue";
import winning from "./components/Modular/winning.vue";
import cash from "./components/Modular/cash.vue";
import cards from "./components/Modular/cards.vue";
import quan from "./components/Modular/quan.vue";
import payWatch from "./components/Modular/payWatch.vue";
import historys from "./components/Modular/historys.vue";
import signIn from "./components/Modular/signIn.vue";
import login from "./components/exchange/login.vue";
import scan from "./components/exchange/scan.vue";
import check from "./components/exchange/check.vue";
import vertical from "./components/Modular/Vertical/vertical.vue";
import telTest from "./components/Modular/telTest.vue";
import goWechat from "./components/Modular/goWechat.vue";
import goodsDetail from "./components/Modular/goodsDetail.vue";
import livestop from "./components/Modular/livestop.vue";
import Companyinformation from "./components/Modular/menu/naturalendowments/Companyinformation.vue";
import Informationpage from "./components/Modular/menu/naturalendowments/Informationpage.vue";
import MyPage from "./components/Modular/menu/PersonalCenter/MyPage.vue";
import Learningrecord from "./components/Modular/menu/PersonalCenter/Learningrecord.vue";
import MyPurchased from "./components/Modular/menu/PersonalCenter/MyPurchased.vue";

// 3.0.2 定义路由规则
var router = new vueRouter({
  linkActiveClass: "mui-active", //改变路由激活时的class名称
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home/",
      component: home,
      name: "home"
    },
    {
      path: "/home/:user",
      component: home,
      name: "home"
    },
    {
      path: "/invite",
      component: invite,
      name: "InviteCard",
      meta: {
        title: "邀请卡",
      },
    },
    {
      path: "/user",
      component: user,
      name: "UserInfo",
      meta: {
        title: "个人中心",
      },
    },
    {
      path: "/set",
      component: Setting,
      name: "Setting",
      meta: {
        title: "设置",
      },
    },
    {
      path: "/sendredbag",
      component: rewardRedBag,
      name: "redbag",
    },
    {
      path: "/income",
      component: income,
      name: "income",
      meta: {
        title: "收入",
      },
    },
    {
      path: "/passWord",
      component: passWord,
      name: "passWord",
    },
    {
      path: "/expend",
      component: expend,
      name: "expend",
      meta: {
        title: "消费",
      },
    },
    {
      path: "/prizes",
      component: prizes,
      name: "prizes",
    },
    {
      path: "/winning",
      component: winning,
      name: "winning",
      meta: {
        title: "奖品中心",
      },
    },
    {
      path: "/cash/:type",
      component: cash,
      name: "cash",
      meta: {
        title: "奖品列表",
      },
    },
    {
      path: "/cards",
      component: cards,
      name: "cards",
      meta: {
        title: "我的卡包",
      },
    },
    {
      path: "/quan/:id",
      component: quan,
      name: "quan",
      meta: {
        title: "我的消费券",
      },
    },
    {
      path: "/payWatch/:type",
      component: payWatch,
      name: "payWatch",
    },
    {
      path: "/payWatch/:type/:user",
      component: payWatch,
      name: "payWatch",
    },
    {
      path: "/telTest",
      component: telTest,
      name: "telTest",
    },
    {
      path: "/historys",
      component: historys,
      name: "historys",
      meta: {
        title: "观看记录",
      },
    },
    {
      path: "/signIn",
      component: signIn,
      name: "signIn",
      meta: {
        title: "签到",
      },
    },
    {
      path: "/login",
      component: login,
      name: "login",
      meta: {
        title: "登录",
      },
    },
    {
      path: "/scan",
      component: scan,
      name: "scan",
      meta: {
        title: "扫码核销",
      },
    },
    {
      path: "/check",
      component: check,
      name: "check",
      meta: {
        title: "核销信息",
      },
    },
    {
      path: "/vertical",
      component: vertical,
      name: "vertical",
      meta: {
        title: "个人直播",
      },
    },
    {
      path: "/vertical/:user",
      component: vertical,
      name: "vertical",
      meta: {
        title: "个人直播",
      },
    },
    {
      path: "/goWechat",
      component: goWechat,
      name: "vertical",
      meta: {
        title: "跳微信小程序",
      }
    },
    {
      path: "/goodsDetail",
      component: goodsDetail,
      name: "goodsDetail",
      meta: {
        title: "商品详情",
      }
    },
    {
      path: "/livestop",
      component: livestop,
      name: "livestop",
      meta: {
        title: "视频暂停",
      }
    },
    {
      path: "/Companyinformation",
      component: Companyinformation,
      name: "Companyinformation",
      meta: {
        title: "公司信息",
      }
    },
    {
      path: "/Informationpage",
      component: Informationpage,
      name: "Informationpage",
      meta: {
        title: "店铺信息",
      }
    },
    {
      path: "/MyPage",
      component: MyPage,
      name: "MyPage",
      meta: {
        title: "我的",
      }
    },
    {
      path: "/Learningrecord",
      component: Learningrecord,
      name: "Learningrecord",
      meta: {
        title: "学习记录",
      }
    },
    {
      path: "/MyPurchased",
      component: MyPurchased,
      name: "MyPurchased",
      meta: {
        title: "我的已购",
      }
    },
  ],
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

import axios from "axios";
import tools, { app_Id } from "./kits/Tools.js";

// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {

    // 不需要拦截的请求
    if(config.url == 'https://webrtc.liveplay.myqcloud.com/webrtc/v1/pullstream'){
      return config;
    }
    if (config.url && config.url.indexOf("/user/index/checkToken") > -1) {
      var msmk_token1 = tools.getCookie('netschool_token')
      config.data = 'token=' + msmk_token1
      return config
    }

    if (config.url && config.url.indexOf("/app/report/errorReport") > -1) {
      return config
    }
    //增加token
    var users = JSON.parse(localStorage.getItem(app_Id));
    if (users) {
      var msmk_token = users.token;
      config.data = "token=" + msmk_token + "&" + config.data;
    }
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    if (response.data.code == 100068 || response.data.code == 100067) {
      if (tools.getIsDeveloper()) {
        alert("测试环境token无效："+JSON.stringify(response.data));
      } else {
        //这里是正式环境需要重新登入
        console.log("response=appId=====" + app_Id);
        if (app_Id) {
          localStorage.removeItem(app_Id);
          localStorage.removeItem("current_app_Id");
          tools.delCookie('netschool_token')
        }
        // tools.login(app_Id, function(res) {
        //   console.log("需要重新登入",res);
        // });
        window.location.reload();
      }
    }

    if (response.data.token && app_Id) {
      var users = JSON.parse(localStorage.getItem(app_Id));
      if (users) {
        users.token = response.data.token;
        localStorage.setItem(app_Id, JSON.stringify(users));
      }
    }

    // 对响应数据做点什么
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

Vue.config.ignoredElements = [
  'wx-open-launch-weapp'
];
Vue.prototype.axios = axios;
// 5.0 利用Vue对象进行解析渲染


import store from './store'


window.app = new Vue({
  el: "#app",
  router,
  store,
  render: (c) => c(App), // es6的函数写法 =>：goes to
});



// WEBPACK FOOTER //
// ./src/main.js